import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column w-350px",
  "data-kt-menu": "true",
  id: "kt-notification-menu"
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createTextVNode(" Notifications "),
    /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-success fs-7 fw-500 ms-3" }, "24 reports")
  ])
], -1)
const _hoisted_4 = { class: "card-body p-0" }
const _hoisted_5 = { class: "mh-350px scroll-y py-3" }
const _hoisted_6 = { class: "symbol symbol-40px symbol-circle me-5" }
const _hoisted_7 = { class: "mb-1 pe-3 flex-grow-1" }
const _hoisted_8 = {
  href: "#",
  class: "fs-6 text-dark text-hover-primary fw-bold"
}
const _hoisted_9 = { class: "text-gray-400 fw-bold fs-7" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "card-footer text-center py-5" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn btn-light btn-active-light-primary btn-sm"
  }, "All Notifications")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "d-flex align-items-center bg-hover-lighten py-3 px-9"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", {
                  class: _normalizeClass([`bg-light-${item.color}`, "symbol-label"])
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass([`svg-icon-${item.color}`, "svg-icon svg-icon-1"])
                  }, [
                    _createVNode(_component_inline_svg, {
                      src: item.icon
                    }, null, 8, ["src"])
                  ], 2)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("a", _hoisted_8, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(item.info), 1)
              ])
            ]))
          }), 128))
        ])
      ]),
      _hoisted_10
    ])
  ]))
}